(function () {
  'use strict';

  /* @ngdoc object
   * @name crewFlyingExperiance
   * @description
   *
   */
  angular
    .module('crewFlyingExperiance', [
      'ui.router'
    ]);
}());
